import axios from 'axios'
import { setInterceptors } from './common/interceptors'

function createInstance (url) {
  const instance = axios.create({
    baseURL: `${process.env.VUE_APP_API_URL}${url}`
  })
  return setInterceptors(instance)
}


export const instance = createInstance('')
